/**
 * @file paddle hack awards
 * @author wanzhongyun
 */

import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { IHackAwards } from './../../type';

import './style.less';


const HackAwards: React.FC<IHackAwards> = props => {

    const {
        titleImageUrl,
        desc,
        detailLink,
        commonAwardsImg,
        specialAwardsImg
    } = props;
    
    return (
        <div className='paddle-hack-awards-wrapper'>
            <img className='paddle-hack-awards-title' src={titleImageUrl} alt='' />
            <div className='paddle-hack-awards-desc'>
                <span>{desc}</span>
                <a href={detailLink} target='_blank' rel="noreferrer">&nbsp;&nbsp;查看详情&nbsp;<RightOutlined /></a>
            </div>
            <img className='paddle-hack-awards-comman' src={commonAwardsImg} alt='' />
            <img className='paddle-hack-awards-special' src={specialAwardsImg} alt='' />
            <div className='paddle-hack-awards-explain'>*以上奖项最终解释权归主办方所有</div>
        </div>
    );
};

export default HackAwards;